import React, { Component } from "react";
import { connect } from "react-redux";

import { Card, Table, Button, Tooltip, DatePicker } from "antd";
import { API_BASE } from "../../utils/contrains";
import { usrRole } from "../../utils/dataUtil";
import {
  req_page_gsm_depart_range_list,
  req_downloadfile_gsm_depart_range,
} from "../../api";
const { RangePicker } = DatePicker;

class DepartmentAnalyzeList extends Component {
  state = {
    loading: false,
    userLevel: "NORMAL",
    items: [],
    item: {},
    isShowModal: false,
    startDateTime: "",
    endDateTime: "",
  };

  UNSAFE_componentWillMount() {
    this.init_columns();
  }

  componentDidMount() {
    this.api_list_items(1);
  }
  // 遠端數據處理 //////////////////////////////////////////////

  api_list_items = async (current) => {
    const { startDateTime, endDateTime } = this.state;
    const { token, userCode, role } = this.props.user;
    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel });

    this.setState({ loading: true, items: [] });
    const result = await req_page_gsm_depart_range_list(
      userLevel,
      userCode,
      startDateTime,
      endDateTime,
      token
    );
    //console.log(result);
    if (result.total > 0) {
      const items = result.data;
      this.setState({ items, loading: false });
    } else {
      const items = [];
      this.setState({ items, loading: false });
    }
  };

  api_downloadfile_items = async () => {
    const { userLevel, startDateTime, endDateTime } = this.state;
    const { token, userCode } = this.props.user;

    const fileUrl = await req_downloadfile_gsm_depart_range(
      userCode,
      userLevel,
      startDateTime,
      endDateTime,
      token
    );

    // download file link
    let a = document.createElement("a");
    a.href = API_BASE + fileUrl;
    a.target = "_blank";
    a.download = "清單";
    a.click();
  };

  // 操作互動處理 //////////////////////////////////////////////

  handle_data_refresh = () => {
    this.api_list_items();
  };

  onRangePickerChange = (value, dateString) => {
    //console.log("Selected Time: ", value);
    //console.log("Formatted Selected Time: ", dateString);
    this.setState({
      startDateTime: dateString[0],
      endDateTime: dateString[1],
    });
  };
  onRangePickerOk = (value) => {
    //console.log("onOk: ", value);
  };

  handle_data_download = () => {
    this.api_downloadfile_items();
  };

  // 數據配置設定 //////////////////////////////////////////////

  init_columns = () => {
    this.columns = [
      {
        title: "學院",
        dataIndex: "CollegeTwName",
        width: 20,
        responsive: ["md"],
        render: (field) => {
          return (
            <div className="text-center">
              <span style={{ fontSize: "1.3em" }}> {field}</span>
            </div>
          );
        },
      },
      {
        title: "系所",
        dataIndex: "DepartmentMainName",
        width: 40,
      },
      {
        title: "人次",
        dataIndex: "DepartmentTotal",
        width: 40,
      },
    ];
  };

  /////////////////////////////////////////////////////////////
  render() {
    const { loading, items } = this.state;
    const title = (
      <>
        <RangePicker
          showTime={{
            format: "HH:mm",
          }}
          format="YYYY-MM-DD HH:mm"
          onChange={this.onRangePickerChange}
          onOk={this.onRangePickerOk}
        />
        <Button type="primary" onClick={() => this.api_list_items()}>
          <i className="fas fa-search element-hidden"></i>
          <span style={{ marginLeft: "4px" }}>查詢</span>
        </Button>{" "}
        <Button type="primary" onClick={() => this.handle_data_download()}>
          <i className="fas fa-cloud-download-alt element-hidden"></i>
          <span style={{ marginLeft: "4px" }}>下載</span>
        </Button>{" "}
        <Tooltip placement="top" title="重新整理">
          <Button type="primary" onClick={() => this.handle_data_refresh()}>
            <i className="fas fa-sync-alt"></i>
          </Button>
        </Tooltip>{" "}
        <p />
      </>
    );
    return (
      <Card>
        {title}
        <Table
          bordered
          loading={loading}
          rowKey="Uid"
          dataSource={items}
          pagination={null}
          columns={this.columns}
        />
      </Card>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(DepartmentAnalyzeList);
